export default __webpack_public_path__ + "static/image-d-53bdf1e263116b48252a5acb47ed1280.webp";